// client/src/routes/app/fiscal/profile.tsx — SCR-FISC-006 „Profil fiscal" · FISC-008 (04 §8.11).
//
// The placeholder UI-003 reserved here is gone; the screen is `features/fiscal`.
//
// Gated on `Fiscal.Read` (§6.2) AND on the owner/accountant pair of §8.11's heading, which
// FISC-007 added to every fiscal route (D-1271): the sidebar hides the entry, and this renders
// SCR-SYS-403 for
// the URL that was typed anyway (§9.2.2). The taxpayer-type editor inside is separately gated on
// `Portfolio.Write`, because the route it calls is PROP-001's and carries PROP-001's code — an
// accountant reads this screen and changes nothing on it (03 §17.1).

import { createFileRoute, redirect } from '@tanstack/react-router';

import { RequireAnyRole, RequirePermission } from '@/components/layout/route-guards';
import { fiscalVisible } from '@/config/fiscal';
import { FiscalProfileScreen } from '@/features/fiscal/FiscalProfileScreen';

export const Route = createFileRoute('/app/fiscal/profile')({
  // Withdrawn from view with the fiscal module (D-2780); see `fiscal/index.tsx`.
  beforeLoad: () => {
    if (!fiscalVisible()) throw redirect({ to: '/app/dashboard' });
  },
  component: FiscalProfileRoute,
});

function FiscalProfileRoute() {
  return (
    <RequirePermission permission="Fiscal.Read">
      {/* FISC-007 added the role gate 04 §8.11's heading asks of every fiscal screen: a manager
          holds `Fiscal.Read` (03 §17.1, D-1236), so the permission alone lets them type this
          URL and read it. See D-1271. */}
      <RequireAnyRole roles={['owner', 'accountant']}>
        <FiscalProfileScreen />
      </RequireAnyRole>
    </RequirePermission>
  );
}
